export const errorImageUrl =
    'https://edge.xero.com/illustration/person-plugging-in-robot-01/person-plugging-in-robot-01.svg';
